import { motion } from "framer-motion";
import Image from "next/legacy/image";
import React from "react";
import Link from "next/link";
import Button from "@/components/actions/Button";
import PlayIconSvg from "@/components/lib/PlayIconSvg";

export default function Trailer({ url = "", className, compact = false }) {
  const extractIdFromVideo = (url) => {
    if (url === null) {
      return "";
    }
    let regExp =
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    let match = url.match(regExp);
    if (match && match[7].length == 11) {
      return match[7];
    }
  };

  const getVideoImage = (url) => {
    const id = extractIdFromVideo(url);
    const imgLink = `https://i.ytimg.com/vi/${id}/default.jpg`;
    return imgLink;
  };

  return (
    <>
      {!compact ? (
        <motion.div
          className={className}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
        >
          <div
            style={{ boxShadow: "limegreen 0px 2px 2px 0px" }}
            className="flex w-[224px] flex-col"
          >
            {/* <div className="w-[227px] h-[144px]">
            <Image
              src={getVideoImage(url)}
              alt=""
              layout='responsive'
              width={227}
              height={144}
            />
          </div> */}
            <Link href={url} legacyBehavior>
              <Button
                className="h-[4rem] w-full"
                color="green"
                label="Ver trailer"
                trailingIcon={
                  <PlayIconSvg className="h-4 w-4 text-neutral-700" />
                }
              ></Button>
            </Link>
            {/* <a href={url} target="_blank" rel="noopener noreferrer">
            <div className="shadow-[0_4px_2px_-2px_limegreen;] bg-green-400 flex justify-center items-center p-[1.28rem]">
              <p>Ver en linea</p>
              <span> {'>'} </span>
            </div>

          </a> */}
          </div>
        </motion.div>
      ) : (
        <div className="flex">
          <div className="h-[40px] w-[60px]">
            <Image
              alt="thumbnail"
              src={getVideoImage(url)}
              height={40}
              width={60}
              layout="responsive"
            />
          </div>
          <a href={url} target="_blank" rel="noopener noreferrer">
            <div className="flex h-full w-60 items-center bg-black/50 pl-8">
              <p> Ver trailer </p>
            </div>
          </a>
        </div>
      )}
    </>
  );
}
